import { render } from "./HistoricoCSU.vue?vue&type=template&id=1b410fe4"
import script from "./HistoricoCSU.vue?vue&type=script&lang=js"
export * from "./HistoricoCSU.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__